export default __webpack_public_path__ + "static/media/dashboardiconclicked.51f5f432.svg";